import { render } from "./RdeMenuMobile.vue?vue&type=template&id=c0961b74"
import script from "./RdeMenuMobile.vue?vue&type=script&lang=js"
export * from "./RdeMenuMobile.vue?vue&type=script&lang=js"

import "./RdeMenuMobile.vue?vue&type=style&index=0&id=c0961b74&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__